import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tns } from 'tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';
import { clearSliders, fetchSliders } from '../store/sliders/sliders.slice';
import { AppDispatch, RootState } from '../store/store';
import { Slider } from '../api/sliders/types';
import fvLoadingImage from '../assets/images/fv-loading.webp';

export default function SliderHome() {
    const dispatch = useDispatch<AppDispatch>();
    const { sliderList, isLoading, errorMessage } = useSelector((state: RootState) => state.sliders);
    const sliderContainerRef = useRef<HTMLDivElement | null>(null); // Referencia al contenedor
    const sliderInstanceRef = useRef<any>(null); // Referencia a la instancia de tiny-slider

    // Cargar sliders al montar el componente
    useEffect(() => {
        dispatch(fetchSliders());
        return () => {
            dispatch(clearSliders()); // Limpiar sliders al desmontar
        };
    }, [dispatch]);

    // Inicializar o destruir el slider manualmente cuando cambien los datos
    useEffect(() => {
        console.log('Inicializar o destruir el slider manualmente cuando cambien los datos', sliderList?.data?.length);
        if (sliderList?.data?.length) {
            // Destruir slider previo si existe
            if (sliderInstanceRef.current) {
                console.log('sliderInstanceRef.current refresh');
                sliderInstanceRef.current.destroy();
                sliderInstanceRef.current = sliderInstanceRef.current.rebuild();
            }else{

            // Asegurar que el DOM esté completamente renderizado antes de inicializar
            const timeout = setTimeout(() => {
                console.log('sliderInstanceRef.current INIT');
                sliderInstanceRef.current = tns({
                    container: sliderContainerRef.current as HTMLElement,
                    items: 1,
                    controls: false,
                    lazyload: true,
                    mouseDrag: true,
                    loop: true,
                    rewind: true,
                    autoplay: true,
                    autoplayButtonOutput: false,
                    autoplayTimeout: 3000,
                    navPosition: 'bottom',
                    controlsText: ['<i class="mdi mdi-chevron-left"></i>', '<i class="mdi mdi-chevron-right"></i>'],
                    nav: false,
                    speed: 400,
                    gutter: 0,
                    swipeAngle: false,
                    autoHeight: true,
                    center: true,
                });

                // sliderInstanceRef.current.refresh();
            }, 10); // Retraso de 100ms para asegurar el renderizado completo
        }
            // Cleanup del timeout
           //  return () => clearTimeout(timeout);
        }

        // Cleanup para destruir el slider al desmontar o actualizar
        return () => {
            // if (sliderInstanceRef.current) {
            //     console.log('sliderInstanceRef.current destroy2');
            //     sliderInstanceRef.current.destroy();
            //     sliderInstanceRef.current = null;
            // }
        };
    }, [sliderList]);

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <img src={fvLoadingImage} className="img-fluid coin-spin" alt="loading" />
            </div>
        );
    }

    if (errorMessage) {
        return <div className="text-center text-danger">Error: {errorMessage}</div>;
    }

    if (!sliderList || !sliderList.data || sliderList.data.length === 0 || !sliderContainerRef) {
        return null; // Evitar renderizar si no hay datos
    }

    console.log('sliderInstanceRef.current RENDER');

    return (
        <div className="tiny-slider" ref={sliderContainerRef}>
            {sliderList.data.map((item: Slider) => (
                <div className="tiny-slide" key={`slider-${item.id}`}>
                    {item.url ? (
                        <a href={item.url} target="_blank" rel="noopener noreferrer" className="cursor-pointer">
                            <img className="img-fluid" src={item.image_desktop_url_permalink} alt={item.name} />
                        </a>
                    ) : (
                        <img className="img-fluid" src={item.image_desktop_url_permalink} alt={item.name} />
                    )}
                </div>
            ))}
        </div>
    );
}
